import { Box, Chip, Typography } from "@mui/material";
import { T } from "../../hooks/useTranslate";
import {
  ArrowDropDownOutlined,
  ArrowDropUpOutlined,
} from "@mui/icons-material";

import { Avatar } from "@unicity/design-system";
import { OfficeBox } from "./../OfficeBox";

const SettingsButton = ({
  rankDetails,
  userInfo,
  menuIsOpen,
  viewportIsSmall,
  openMenu,
  menuAnchorRef
}) => {
  return (
    <OfficeBox
      aria-label="open settings menu"
      className="flex-row settings-menu"
      onClick={openMenu}
      innerRef={menuAnchorRef}
      sx={{
        padding: "10px"
      }}
      id="settingsContainer"
    >
      <Avatar
        id="settingsAvatar"
        alt={userInfo?.name}
        src={userInfo?.profilePictureUrl}
        sx={{ width: 25, height: 25 }}
      />
      {viewportIsSmall && (
        <>
          <Box id="settingsUsername"
            ml={1}
            mr={1}
            sx={{
              fontWeight: 600,
              fontSize: "calc(12px * var(--unicity-font-scale, 1))"
            }}
          >
            {userInfo.name}
          </Box>
          {userInfo?.isAffiliate ? (
            <Chip
              data-test-id="settings-button-affiliate-chip"
              className="u-chip"
              label={
                <Typography sx={{ fontSize: "calc(10px * var(--unicity-font-scale, 1))", fontWeight: "600" }}>
                  <T>affiliate</T>
                </Typography>
              }
            />
          ) : (
            rankDetails?.rankTranslateAbbrKey && (
              <Chip
                data-test-id="settings-button-rank-chip"
                className="u-chip"
                variant={`rank-${rankDetails?.rankId}`}
                label={
                  <Typography sx={{ fontSize: "calc(10px * var(--unicity-font-scale, 1))", fontWeight: "600" }}>
                    <T>{rankDetails?.rankTranslateFullKey}</T>
                  </Typography>
                }
              />
            )
          )}
        </>
      )}
      <Box>
        {menuIsOpen ? (
          <ArrowDropUpOutlined />
        ) : (
          <ArrowDropDownOutlined />
        )}
      </Box>
    </OfficeBox>
  )
}

export { SettingsButton }